<template>
  <footer class="footer">
    <div class="container">
      <nav>
        <ul>
          <li>
            <a href="/dashboard">Dashboard</a>
          </li>
          <li>
            <a href="/listings"> Listings </a>
          </li>
          <li>
            <a href="/reservations"> Reservations </a>
          </li>
<!--          <li>-->
<!--            <a href="https://www.creative-tim.com/license"> Licenses </a>-->
<!--          </li>-->
        </ul>
      </nav>
      <div class="copyright text-center">
        &copy; {{ new Date().getFullYear() }}
<!--        <a href="https://www.creative-tim.com/?ref=mdf-vuejs" target="_blank">Creative Tim</a>, -->
        Crafted with <i class="fa fa-heart heart"></i> for a better web.
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style></style>
